import React from 'react';
import PropTypes from 'prop-types';

import { EXPAND_ARROW, COLLAPSE_ARROW } from '../../../utils/trackingLinks';
import Campaign from './Campaign';
import ArchiveIcon from '../../../resources/svg/archive_grey.svg';

const Network = ({
    campaigns = {},
    css = {},
    enabledCampaignEditing = false,
    expanded = false,
    expandedCampaigns = [],
    toggleExpand = () => {},
    app_id = null,
    network = '',
    linkType = '',
    toggleExpandCampaign = () => {},
    deleteClicked = () => {},
    editCampaignName = () => {},
    editClicked = () => {},
    editingCampaign = '',
}) => {
    return (
        <div className={css.NetworkPanel}>
            <div className={`${css.NetworkHeading} ${css.Expand}`}>
                <div
                    className={`${css.NetworkName} ${css.Expand}`}
                    onClick={() => {
                        toggleExpand(app_id, network);
                    }}
                >
                    {expanded ? COLLAPSE_ARROW : EXPAND_ARROW}
                </div>
                <div
                    className={`${css.NetworkName} ${css.TextWrapper}`}
                    onClick={() => {
                        toggleExpand(app_id, network);
                    }}
                >
                    <span>{linkType === 'SmartLink' ? `${network} - Smart Link` : network}</span>
                    <span className={css.NetworkPanelText}>
                        {`(${Object.keys(campaigns).length} ${
                            Object.keys(campaigns).length > 1 ? 'Campaigns' : 'Campaign'
                        })`}
                    </span>
                    <span
                        className={css.deleteButton}
                        onClick={e => {
                            e.stopPropagation();
                            deleteClicked(Object.keys(campaigns));
                        }}
                        style={{ marginLeft: '20px', verticalAlign: 'top' }}
                    >
                        <ArchiveIcon
                            style={{
                                height: '15px',
                                width: '15px',
                                marginTop: '3px',
                            }}
                        />
                    </span>
                </div>
            </div>
            {expanded && (
                <div className={css.CampaignsContainer}>
                    {Object.keys(campaigns)
                        .sort()
                        .map(campaignID => (
                            <Campaign
                                css={css}
                                network={network}
                                app_id={app_id}
                                key={`campaign_${campaignID}`}
                                campaign_id={campaignID}
                                campaign={campaigns[campaignID].campaign_name}
                                data={campaigns[campaignID]}
                                expanded={expandedCampaigns.indexOf(campaignID) > -1}
                                toggleExpand={toggleExpandCampaign}
                                deleteClicked={deleteClicked}
                                editCampaignName={editCampaignName}
                                editClicked={editClicked}
                                editingCampaign={editingCampaign}
                                enabledCampaignEditing={enabledCampaignEditing}
                            />
                        ))}
                </div>
            )}
        </div>
    );
};

Network.propTypes = {
    app_id: PropTypes.number,
    campaigns: PropTypes.objectOf(PropTypes.any),
    css: PropTypes.objectOf(PropTypes.any),
    deleteClicked: PropTypes.func,
    editCampaignName: PropTypes.func,
    editClicked: PropTypes.func,
    editingCampaign: PropTypes.string,
    enabledCampaignEditing: PropTypes.bool,
    expanded: PropTypes.bool,
    expandedCampaigns: PropTypes.arrayOf(PropTypes.any),
    linkType: PropTypes.string,
    network: PropTypes.string,
    toggleExpand: PropTypes.func,
    toggleExpandCampaign: PropTypes.func,
};

export default Network;
